import { useContext } from 'preact/hooks';

import { emptyCountry, AppContext } from '../../context/AppContext';
import RegionSelect from './RegionSelect';
import { Region } from '../../../../types';

export default function RegionFilter( { wpRegionTerms }: { wpRegionTerms: Region[] } ) {
	const { filterContext } = useContext( AppContext );
	const [ filterState, dispatch ] = filterContext;
	const { region } = filterState;

	const handleRegionChange = ( value: Region ) => {
		dispatch( { type: 'SET_REGION', payload: value } );
		dispatch( { type: 'SET_ACTIVE_COUNTRY', payload: emptyCountry } );
	};

	return (
		<RegionSelect
			wpRegionTerms={ wpRegionTerms }
			handleRegionChange={ handleRegionChange }
			region={ region }
		/>
	);
}
